<template>
    <!-- 模拟计算 -->
    <div>
      <div>
        <img class="top_img1" src="../../assets/img/monijisuan.jpg" />
      </div>
      <div class="calculation">
        <div class="calculation_main">
          <div class="left">
            <el-menu
              :default-active="defaultActive"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              unique-opened
              style="min-width: 260px"
              @close="handleClose"
              @select="selectSub"
            >
              <el-submenu index="1">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>第一性原理</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="1-1">差分电荷密度</el-menu-item>
                  <el-menu-item index="1-2">电子局域函数</el-menu-item>
                  <el-menu-item index="1-3">分波态密度</el-menu-item>
                  <el-menu-item index="1-4">吉布斯自由能</el-menu-item>
                  <el-menu-item index="1-5">能带结构</el-menu-item>
                  <el-menu-item index="1-6">迁移势垒</el-menu-item>
                  <el-menu-item index="1-7">原子电荷</el-menu-item>
                  <el-menu-item index="1-8">吸附模型</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="2">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>分子动力学</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1">蛋白研究</el-menu-item>
                  <el-menu-item index="2-2">电池性能</el-menu-item>
                  <el-menu-item index="2-3">反应化学分析</el-menu-item>
                  <el-menu-item index="2-4">分子动力学</el-menu-item>
                  <el-menu-item index="2-5">分子对接</el-menu-item>
                  <el-menu-item index="2-6">分子自组装</el-menu-item>
                  <el-menu-item index="2-7">碳纳米管研究</el-menu-item>
                  <el-menu-item index="2-8">相转变</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>相图计算</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="3-1">比热容计算</el-menu-item>
                  <el-menu-item index="3-2">二元体系热力学数据库建设</el-menu-item>
                  <el-menu-item index="3-3">混合焓计算</el-menu-item>
                  <el-menu-item index="3-4">活度计算</el-menu-item>
                  <el-menu-item index="3-5">热力学数据库建设</el-menu-item>
                  <el-menu-item index="3-6">三元体系热力学数据库建设</el-menu-item>
                  <el-menu-item index="3-7">相成分计算</el-menu-item>
                  <el-menu-item index="3-8">形成焓计算</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="4">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>有限元</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="4-1">voronoi类型的晶粒生长</el-menu-item>
                  <el-menu-item index="4-2">单颗粒的电磁场增强</el-menu-item>
                  <el-menu-item index="4-3">电极微观结构中的静水压分布</el-menu-item>
                  <el-menu-item index="4-4">力一化学耦合的内聚力单无</el-menu-item>
                  <el-menu-item index="4-5">模拟电极材料晶界断</el-menu-item>
                  <el-menu-item index="4-6">二维枝晶生长</el-menu-item>
                  <el-menu-item index="4-7">两相流:油水界面</el-menu-item>
                  <el-menu-item index="4-8">相场法模拟轴向拉伸断裂</el-menu-item>
                  <el-menu-item index="4-9">形核生长</el-menu-item>
                  <el-menu-item index="4-10">自发相分离</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
          </div>
          <div class="right">
            <div class="header">
              <div class="header_img">
                <img :src="headerImg" alt="" />
              </div>
              <div class="header_content">
                <div class="header_title">{{headerTitle}}</div>
                <div class="header_btns">
                  <el-button type="primary" class="clickMoni" @click="order" size="small">立即预约</el-button>
                  <el-button type="primary" class="clickMoni" size="small" @click="openKefu">联系客服</el-button>
                </div>
              </div>
            </div>
            <div class="body">
              <div class="body_content">
                <div class="body_title">
                  <div class="body_title_icon">
                    <img src="../../assets/img/moni/xmjs.png" alt="" />
                  </div>
                  <div class="body_title_text">项目介绍</div>
                </div>
                <div class="content">
                  <div v-html="headerContent"></div>
                </div>
              </div>
              <div class="body_content">
                <div class="body_title">
                  <div class="body_title_icon">
                    <img src="../../assets/img/moni/xmjs.png" alt="" />
                  </div>
                  <div class="body_title_text">项目介绍</div>
                </div>
                <div class="body_btns">
                  <el-tag
                    id="invoiceTag"
                    @click="filesHandle(item)"
                    v-for="item in filesitems"
                    :key="item.index"
                    :effect="item.flag ? 'dark' : 'light'"
                    :type="item.flag ? '' : 'info'"
                    >{{ item.name }}</el-tag
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step">
        <div class="step_main">
          <div class="step_title">
            <div class="cn">下单步骤</div>
            <div class="en">ORDER PLACEMENT STEP</div>
          </div>
          <div class="step_list">
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step1.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">提交需求</div>
                <div class="step_text">选择对应计算项目直接下单</div>
                <div class="step_text">或者通过在线客服沟通需求</div>
              </div>
            </div>
            <div class="next">
              <img src="../../assets/img/moni/next.jpg" alt="" />
            </div>
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step2.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">免费评估</div>
                <div class="step_text">工程师线上会议沟通需求</div>
                <div class="step_text">评估计算周期及费用</div>
              </div>
            </div>
            <div class="next">
              <img src="../../assets/img/moni/next.jpg" alt="" />
            </div>
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step3.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">合同签定</div>
                <div class="step_text">确认计算方案无误后</div>
                <div class="step_text">签定合同&支付定金</div>
              </div>
            </div>
            <div class="next">
              <img src="../../assets/img/moni/next.jpg" alt="" />
            </div>
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step4.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">进度跟踪</div>
                <div class="step_text">项目专人全程跟踪</div>
                <div class="step_text">定期反馈计算进度</div>
              </div>
            </div>
            <div class="next">
              <img src="../../assets/img/moni/next.jpg" alt="" />
            </div>
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step5.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">审核报告</div>
                <div class="step_text">质检团队联合评审</div>
                <div class="step_text">对计算结果负责到底</div>
              </div>
            </div>
            <div class="next">
              <img src="../../assets/img/moni/next.jpg" alt="" />
            </div>
            <div class="step_item">
              <div class="step_item_img">
                <img src="../../assets/img/moni/step6.jpg" alt="" />
              </div>
              <div class="step_item_content">
                <div class="step_content_title">交付结果</div>
                <div class="step_text">查阅报告及计算结果</div>
                <div class="step_text">售后答疑及保密管理</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="post" id="post">
        <contentIndex :initInfo="info"></contentIndex>
      </div>
      <kefu-pop v-if="kefuVisble" @close="close"></kefu-pop>
    </div>
  </template>
  <script>
  import uploadText from "../common/uploadText";
  import kefuPop from "./pop/kefuPop.vue"
  import contentIndex from "./index.vue"

  export default {
    components: { uploadText , kefuPop, contentIndex},
    data() {
      return {
        info: {
          type: 7,
          testTypeList: [],
        },
        form: {
          computeRequirement: '第一性原理',
          type: 4,
          fileList: []
        },
        rules: {},
        kefuVisble: false,
        defaultActive: "1-1",
        headerTitle: '第一性原理',
            headerContent: '<div style="text-indent: 2em;">第一性原理是指不使用经验参数，只通过基本物理常量 （me、c、e、h、kB） 来计算微观体系基本性质的方法。它包括基于密度泛函的从头算和基于Hartree-Fock自洽计算的从头算，前者以电子密度作为基本变量（Hohenberg-Kohn定理），通过求解Kohn-Sham方程，进行迭代自洽得到体系的基态电子密度，进而求得体系的基态性质；后者则通过自洽求解Hartree-Fock方程，获得体系的波函数进而求得基态性质。</div><div style="text-indent: 2em;">计算内容包括：使用VASP/MS进行晶体结构优化，能带结构计算，态密度（dos）、分态密度（PDOS）计算，差分电荷密度、电荷局域密度（ELF）计算，表面吸附能、空位形成能计算，界面能计算，催化反应路径，弹性性能计算。</div>',
        headerImg: require("../../assets/img/moni/1-1.png"),
        filesitems: [
          { name: "差分电荷密度", index: "1-1", flag: true },
          { name: "电子局域函数", index: "1-2", flag: false },
          { name: "分波态密度", index: "1-3", flag: false },
          { name: "吉布斯自由能", index: "1-4", flag: false },
          { name: "能带结构", index: "1-5", flag: false },
          { name: "迁移势垒", index: "1-6", flag: false },
          { name: "原子电荷", index: "1-7", flag: false },
          { name: "吸附模型", index: "1-8", flag: false },
        ],
      };
    },
    methods: {
      handleOpen(key, keyPath) {
        //   console.log(key, keyPath);
        if (key === "1") {
          this.defaultActive = "1-1";
          this.headerTitle = "第一性原理"
              this.headerContent='<div style="text-indent: 2em;">第一性原理是指不使用经验参数，只通过基本物理常量 （me、c、e、h、kB） 来计算微观体系基本性质的方法。它包括基于密度泛函的从头算和基于Hartree-Fock自洽计算的从头算，前者以电子密度作为基本变量（Hohenberg-Kohn定理），通过求解Kohn-Sham方程，进行迭代自洽得到体系的基态电子密度，进而求得体系的基态性质；后者则通过自洽求解Hartree-Fock方程，获得体系的波函数进而求得基态性质。</div><div style="text-indent: 2em;">计算内容包括：使用VASP/MS进行晶体结构优化，能带结构计算，态密度（dos）、分态密度（PDOS）计算，差分电荷密度、电荷局域密度（ELF）计算，表面吸附能、空位形成能计算，界面能计算，催化反应路径，弹性性能计算。</div>'
          this.form.computeRequirement = "第一性原理"
          this.headerImg = require("../../assets/img/moni/1-1.png")
          this.filesitems = [
            { name: "差分电荷密度", index: "1-1", flag: true },
            { name: "电子局域函数", index: "1-2", flag: false },
            { name: "分波态密度", index: "1-3", flag: false },
            { name: "吉布斯自由能", index: "1-4", flag: false },
            { name: "能带结构", index: "1-5", flag: false },
            { name: "迁移势垒", index: "1-6", flag: false },
            { name: "原子电荷", index: "1-7", flag: false },
            { name: "吸附模型", index: "1-8", flag: false },
          ];
        }
        if (key === "2") {
          this.defaultActive = "2-1";
          this.headerTitle = "分子动力学"
              this.headerContent = '<div style="text-indent: 2em;">分手的力学要阳理强美牛楼力事来想路分手近动的方生，超地在西力手准系的不同城添的限如系年中油政期本来我体系的份业贸分，并以构型积分为基础进一步计算体系的热力学量和其它宏观性质。</div><div style="text-indent: 2em;">计算内容包括：使用LAMMPS计算径向分布函数、MSD和扩散系数，拉伸模拟，应力应变模拟，比热容模拟计算，溶解度模拟。</div>'
          this.form.computeRequirement = "分子动力学"
          this.headerImg = require("../../assets/img/moni/2-1.png")
          this.filesitems = [
            { name: "蛋白研究", index: "2-1", flag: true },
            { name: "电池性能", index: "2-2", flag: false },
            { name: "反应化学分析", index: "2-3", flag: false },
            { name: "分子动力学", index: "2-4", flag: false },
            { name: "分子对接", index: "2-5", flag: false },
            { name: "分子自组装", index: "2-6", flag: false },
            { name: "碳纳米管研究", index: "2-7", flag: false },
            { name: "相转变", index: "2-8", flag: false },
          ];
        }
        if (key === "3") {
          this.defaultActive = "3-1";
          this.headerTitle = "相图计算"
          this.headerContent = '<div style="text-indent: 2em;">相图计算是指在一个多相体系中，随温度、压力和浓度的变化，相的种类、数量及含量都要相应地发生变化，对于变化情况可用几何图形来描绘，这个图形就可以反映出该系统在一定组成、温度和压力下，达到平衡时所处的状态，这个几何图形称为相图，也叫平衡图、状态图。相图是研究材料成分、工艺、结构与性能之间关系的重要基础。</div><div style="text-indent: 2em;">适合的研究方向包括但不限于：金属材料、非金属材料、纳米材料、半导体材料、电催化光催化、热催化、电池、固体、界面、吸附等。</div><div style="text-indent: 2em;">可以计算的体系包括但不限于：晶体、非晶、二维材料、表面、界面、固体等。</div>'
          this.form.computeRequirement = "相图计算"
          this.headerImg = require("../../assets/img/moni/3-1.png")
          this.filesitems = [
            { name: "比热容计算", index: "3-1", flag: true },
            { name: "二元体系热力学数据库建设", index: "3-2", flag: false },
            { name: "混合焓计算", index: "3-3", flag: false },
            { name: "活度计算", index: "3-4", flag: false },
            { name: "热力学数据库建设", index: "3-5", flag: false },
            { name: "三元体系热力学数据库建设", index: "3-6", flag: false },
            { name: "相成分计算", index: "3-7", flag: false },
            { name: "形成焓计算", index: "3-8", flag: false },
          ];
        }
        if (key === "4") {
          this.defaultActive = "4-1";
          this.headerTitle = "有限元"
              this.headerContent = '<div style="text-indent: 2em;">有限元法是一种求解偏微分方程的数值计算方法。其本质是通过将结构离散化，产生有限个容易分析求解的单元，从而将连续体看作是仅在节点处连接的有限个单元的集合。通过有限元方程组求解各个节点值，代入到表示单元内场分布规律的插值函数中，就可以得到整个连续体的场函数。</div><div style="text-indent: 2em;">计算内容包括：利用Ansys、Comsol、Fluent等模拟塑性成型，热管理、多层复合结构热防护、多相流动与传热，结构力学，压电效应，电容，锂离子电池相关，锂金属沉积枝晶问题，固态电解质问题，扩散问题，盐差发电，光散射问题，光催化下等离子共振场增强效应，体积膨胀应力等。</div><div style="text-indent: 2em;">利用Aspen等流程模拟软件进行化工工艺流程的模拟计算，可进行含精馏、萃取、吸收、蒸发（含间歇操作）以及反应等整个工艺流程的物料和热量衡算，并进行各单体设备的尺寸计算（主要是换热器、HTR/和精馏塔、FRI）</div>'
          this.form.computeRequirement = "有限元"
          this.headerImg = require("../../assets/img/moni/4-1.png")
          this.filesitems = [
            { name: "voronoi类型的晶粒生长", index: "4-1", flag: true },
            { name: "单颗粒的电磁场增强", index: "4-2", flag: false },
            { name: "电极微观结构中的静水压分布", index: "4-3", flag: false },
            { name: "力一化学耦合的内聚力单无", index: "4-4", flag: false },
            { name: "模拟电极材料晶界断", index: "4-5", flag: false },
            { name: "二维枝晶生长", index: "4-6", flag: false },
            { name: "两相流:油水界面", index: "4-7", flag: false },
            { name: "相场法模拟轴向拉伸断裂", index: "4-8", flag: false },
            { name: "形核生长", index: "4-9", flag: false },
            { name: "自发相分离", index: "4-10", flag: false },
          ];
        }
        //   console.log(this.defaultActive);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      order(){
        document.getElementById('post').scrollIntoView({ behavior: 'smooth' });
      },
      openKefu(){
        this.kefuVisble = true
      },
      close(){
        this.kefuVisble = false
      },
      filesHandle(item) {
        this.filesitems.map((items) => {
          items.flag = false;
        });
        item.flag = !item.flag;
        this.defaultActive = item.index;
        this.headerImg = require(`../../assets/img/moni/${item.index}.png`);
        // tj
      },
      selectSub(key, keyPath) {
        // console.log(key,keyPath);
        this.filesitems.map((items) => {
          items.flag = false;
          if (items.index === key) {
            items.flag = true;
            this.headerImg = require(`../../assets/img/moni/${items.index}.png`);
          }
        });
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .calculation {
    width: 100%;
    background: #f8f8f8;
    .calculation_main {
      max-width: 1920px;
      min-width: 1500px;
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      .left {
        width: 285px;
        padding: 20px 0;
      }
      .right {
        width: 1250px;
        .header {
          width: 1250px;
          height: 230px;
          background: #ffffff;
          margin-top: 20px;
          display: flex;
          .header_img {
            width: 180px;
            height: 180px;
            margin: 25px;
            border: 1px dashed #eeeeee;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .header_content {
            margin-left: 30px;
            margin-top: 20px;
            height: 180px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .header_title {
              font-size: 24px;
              padding-top: 10px;
              font-weight: bold;
              color: #333333;
            }
          }
        }
        .body {
          width: 1250px;
          background: #ffffff;
          margin-top: 25px;
          .body_content {
            .body_title {
              padding: 20px;
              width: 96%;
              margin: 0 auto;
              display: flex;
              border-bottom: 1px solid #e4e4e4;
              .body_title_icon {
                width: 28px;
                height: 28px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .body_title_text {
                font-size: 16px;
                padding-left: 10px;
                font-weight: bold;
              }
            }
            .content {
              height: 200px;
              padding: 20px;
            }
            .body_btns {
              width: 96%;
              // margin-top: 20px;
              margin: 20px auto;
              display: flex;
              flex-wrap: wrap;
            }
          }
        }
      }
    }
  }
  .clickMoni {
    width: 180px;
    height: 42px;
    background: #4d6ffe;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFang-SC-Semibold, PingFang-SC;
    margin-top: 10px;
  }
  .step {
    width: 100%;
    background: #ffffff;
    .step_main {
      width: 75%;
      margin: 0 auto;
      .step_title {
        text-align: center;
        padding-top: 140px;
        .cn {
          font-size: 26px;
          font-weight: bold;
          color: #566ef2;
        }
        .en {
          color: #333333;
          padding-top: 5px;
        }
      }
      .step_list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 140px;
        .next {
          width: 30px;
          height: 17px;
          margin: 0 20px;
        }
        .step_item {
          width: 224px;
          height: 268px;
          .step_item_img {
            width: 224px;
            height: 134px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .step_item_content {
            background: #eeeeee;
            padding-bottom: 20px;
            .step_content_title {
              font-size: 16px;
              text-align: center;
              color: #333333;
              font-weight: bold;
              line-height: 44px;
              padding-top: 5px;
            }
            .step_text {
              text-align: center;
              padding-bottom: 5px;
            }
          }
        }
      }
    }
  }
  .post {
    width: 100%;
    padding-top: 50px;
    background: #ffffff;
    .post_main {
      width: 80%;
      margin: 0 auto;
      .post_title {
        text-align: center;
        .cn {
          font-size: 26px;
          font-weight: bold;
          color: #566ef2;
        }
        .en {
          color: #333333;
          padding-top: 5px;
        }
      }
      .post_form {
        padding-top: 140px;
      }
    }
  }
  </style>